/**
 * qq相关
 */
const host = location.host || location.hostname;
const protocol = location.protocol || 'https:';
const ptlogin = {
    appid: 1600000279,
    appid_qq: 1600001230, // 文案展示QQ手机版
    proxyUrl: encodeURIComponent(`${protocol}//${host}/static_proxy/qidian/src/comp/login/proxy.html`),
    successUrl: encodeURIComponent(`${protocol}//${host}/static_proxy/qidian/src/comp/login/redirect.html?host=${host}&protocol=${protocol}&url=${window.location.href}`),
    domainId: 358,
};
export default ptlogin;
